import { render, staticRenderFns } from "./Two-ItemTable.vue?vue&type=template&id=290f4440&"
import script from "./Two-ItemTable.vue?vue&type=script&lang=js&"
export * from "./Two-ItemTable.vue?vue&type=script&lang=js&"
import style0 from "./Two-ItemTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports